import {authHeader} from './auth-header';
import {userService} from './';

export const deviceService = {
    updateDevice,
    getDevicesData,
    calcStats,
    copyStats,
    saveToFile,
    updateStats
};

const config = {apiUrl: 'https://hive-backend.com/api/v1/'}

function saveToFile(data, filename, type) {
    var file = new Blob([data], {type: type});
    if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
        var a = document.createElement("a"),
                url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);  
        }, 0); 
    }
}

function updateDevice(deviceId, queryDateRange) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json', 'Accept-Encoding': 'gzip' }
    };

    return fetch(`${config.apiUrl}device/${deviceId}/data?filter=${queryDateRange}&limit=1000`, requestOptions)
    .then(response => {
        if (!response.ok){
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
                return Promise.reject({message: response.statusText});
            }
    
            return response.text()
                .then(data => {
                    if (data === '')
                        return Promise.reject({message: response.statusText});
                    else    
                        return Promise.reject({message: data});
                });
        }

        if (response.status === 204){
            return {deviceId: deviceId, data: []}
        }

        return response.json();
    })
    .catch(err => {
        return Promise.reject(err.message);
    });
}

function getDevicesData(deviceIds, queryDateRange) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json', 'Accept-Encoding': 'gzip' }
    };

    return fetch(`${config.apiUrl}devices/data/?deviceIds=${deviceIds}&filter=${queryDateRange}&limit=1000`, requestOptions)
    .then(response => {
        if (!response.ok){
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
                return Promise.reject({message: response.statusText});
            }
    
            return response.text()
                .then(data => {
                    if (data === '')
                        return Promise.reject({message: response.statusText});
                    else    
                        return Promise.reject({message: data});
                });
        }

        if (response.status === 204){

            return {devices: []}
        }

        return response.json();
    })
    .catch(err => {
        return Promise.reject(err.message);
    });
}

// function calcStats(deviceData, weekStart){
//     let haveData = false;
//     let haveStart = false;
//     let totPressed = 0
//     let promoters = 0;
//     let detractors = 0;
//     let aButtonPresses = 0;
//     let bButtonPresses = 0;
//     let cButtonPresses = 0;
//     let dButtonPresses = 0;
//     let eButtonPresses = 0;
//     let aButtonTemp = 0;
//     let bButtonTemp = 0;
//     let cButtonTemp = 0;
//     let dButtonTemp = 0;
//     let eButtonTemp = 0;
//     let aButtonStart = 0;
//     let bButtonStart = 0;
//     let cButtonStart = 0;
//     let dButtonStart = 0;
//     let eButtonStart = 0;

//     for (let i = 0; i < deviceData.length; i++){
//         let sampleTime = new Date(deviceData[i].time);
        
//         if (sampleTime >= weekStart && haveStart){
//             haveData = true;
//             if (aButtonTemp > deviceData[i].aButtonPresses)
//                 aButtonPresses += aButtonTemp;
//             aButtonTemp = deviceData[i].aButtonPresses;
//             if (bButtonTemp > deviceData[i].bButtonPresses)
//                 bButtonPresses += bButtonTemp;
//             bButtonTemp = deviceData[i].bButtonPresses;
//             if (cButtonTemp > deviceData[i].cButtonPresses)
//                 cButtonPresses += cButtonTemp;
//             cButtonTemp = deviceData[i].cButtonPresses;
//             if (dButtonTemp > deviceData[i].dButtonPresses)
//                 dButtonPresses += dButtonTemp;
//             dButtonTemp = deviceData[i].dButtonPresses;
//             if (eButtonTemp > deviceData[i].eButtonPresses)
//                 eButtonPresses += eButtonTemp;
//             eButtonTemp = deviceData[i].eButtonPresses;
//         }else{
//             aButtonStart = aButtonTemp = deviceData[i].aButtonPresses;
//             bButtonStart = bButtonTemp = deviceData[i].bButtonPresses;
//             cButtonStart = cButtonTemp = deviceData[i].cButtonPresses;
//             dButtonStart = dButtonTemp = deviceData[i].dButtonPresses;
//             eButtonStart = eButtonTemp = deviceData[i].eButtonPresses;
//             haveStart = true;
//         }
//     }
//     if (haveData){
//         aButtonPresses = aButtonPresses + aButtonTemp - aButtonStart;
//         bButtonPresses = bButtonPresses + bButtonTemp - bButtonStart;
//         cButtonPresses = cButtonPresses + cButtonTemp - cButtonStart;
//         dButtonPresses = dButtonPresses + dButtonTemp - dButtonStart;
//         eButtonPresses = eButtonPresses + eButtonTemp - eButtonStart;
//     }
//     totPressed = aButtonPresses + bButtonPresses + cButtonPresses + 
//         dButtonPresses + eButtonPresses;
//     promoters = aButtonPresses;
//     detractors = eButtonPresses;

//     return {
//         npsScore: (promoters / totPressed * 100) - (detractors / totPressed * 100),
//         aButtonPresses,
//         bButtonPresses,
//         cButtonPresses,
//         dButtonPresses,
//         eButtonPresses
//     };
//}

function calcStats(deviceData, weekStart){
    let aButtonPresses = 0;
    let bButtonPresses = 0;
    let cButtonPresses = 0;
    let dButtonPresses = 0;
    let eButtonPresses = 0;
    let aButtonTemp = 0;
    let bButtonTemp = 0;
    let cButtonTemp = 0;
    let dButtonTemp = 0;
    let eButtonTemp = 0;
    let lastWeek = true;
    let dayNumber = 0;
    let hourNumber = 0;
    let aButtonHourStart = 0;
    //let bButtonHourStart = 0;
    let cButtonHourStart = 0;
    //let dButtonHourStart = 0;
    let eButtonHourStart = 0;
    let aButtonDayStart = 0;
    //let bButtonDayStart = 0;
    let cButtonDayStart = 0;
    //let dButtonDayStart = 0;
    let eButtonDayStart = 0;
    let aButtonWeekStart = 0;
    let bButtonWeekStart = 0;
    let cButtonWeekStart = 0;
    let dButtonWeekStart = 0;
    let eButtonWeekStart = 0;
    let lastWeekData = deepCopyWeekData(weekData);
    let thisWeekData = deepCopyWeekData(weekData);
    let day = 0;
    let week = 0;
    let npsScore = NaN;
    let npsPrevScore = NaN;
    let delta = NaN;

    if (deviceData.length !== 0){
    
        let startTime = new Date(deviceData[0].time);
        dayNumber = startTime.getDay() === 0 ? 6 : startTime.getDay() - 1;
        hourNumber = startTime.getHours();
        aButtonTemp = aButtonHourStart = aButtonDayStart = deviceData[0].aButtonPresses;
        bButtonTemp = /*bButtonHourStart = bButtonDayStart = */deviceData[0].bButtonPresses;
        cButtonTemp = cButtonHourStart = cButtonDayStart = deviceData[0].cButtonPresses;
        dButtonTemp = /*dButtonHourStart = dButtonDayStart = */deviceData[0].dButtonPresses;
        eButtonTemp = eButtonHourStart = eButtonDayStart = deviceData[0].eButtonPresses;
        day = startTime.getDate();
        week = ISO8601_week_no(startTime);
                
        let prevIndex = 0;
        for (let i = 0; i < deviceData.length; i++){
            let sampleTime = new Date(deviceData[i].time);
            
            if (lastWeek && sampleTime > weekStart){
                lastWeek = false;

                aButtonHourStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                //bButtonHourStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                cButtonHourStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                //dButtonHourStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                eButtonHourStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                aButtonDayStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                //bButtonDayStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                cButtonDayStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                //dButtonDayStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                eButtonDayStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                aButtonWeekStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                bButtonWeekStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                cButtonWeekStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                dButtonWeekStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                eButtonWeekStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
        
                hourNumber = sampleTime.getHours();
                dayNumber = sampleTime.getDay() === 0 ? 6 : sampleTime.getDay() - 1;
                day = sampleTime.getDate();
                week = ISO8601_week_no(sampleTime);
            }
            else{
                // Check if hour change
                let h = sampleTime.getHours();
                if (hourNumber !== h){
                    // Save Hour data
                    aButtonHourStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                    //bButtonHourStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                    cButtonHourStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                    //dButtonHourStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                    eButtonHourStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                
                    hourNumber = h;
                }
                
                // Check if day change
                let d = sampleTime.getDay() === 0 ? 6 : sampleTime.getDay() - 1;
                if (dayNumber !== d){
                    // Save Day data
                    aButtonDayStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                    //bButtonDayStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                    cButtonDayStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                    //dButtonDayStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                    eButtonDayStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                    
                    dayNumber = d;
                    day = sampleTime.getDate();
                    week = ISO8601_week_no(sampleTime);
                }
            }
            if (aButtonTemp > deviceData[i].aButtonPresses)
                aButtonPresses += aButtonTemp;
            aButtonTemp = deviceData[i].aButtonPresses;
            if (bButtonTemp > deviceData[i].bButtonPresses)
                bButtonPresses += bButtonTemp;
            bButtonTemp = deviceData[i].bButtonPresses;
            if (cButtonTemp > deviceData[i].cButtonPresses)
                cButtonPresses += cButtonTemp;
            cButtonTemp = deviceData[i].cButtonPresses;
            if (dButtonTemp > deviceData[i].dButtonPresses)
                dButtonPresses += dButtonTemp;
            dButtonTemp = deviceData[i].dButtonPresses;
            if (eButtonTemp > deviceData[i].eButtonPresses)
                eButtonPresses += eButtonTemp;
            eButtonTemp = deviceData[i].eButtonPresses;

            if (lastWeek){
                lastWeekData.week = week;
                lastWeekData.responses[dayNumber].day = day;
                lastWeekData.responses[dayNumber].happyCnt = aButtonTemp + 
                    aButtonPresses - aButtonDayStart;
                lastWeekData.responses[dayNumber].neutralCnt = cButtonTemp +
                    cButtonPresses - cButtonDayStart;
                lastWeekData.responses[dayNumber].sadCnt = eButtonTemp + 
                    eButtonPresses - eButtonDayStart;
                lastWeekData.responses[dayNumber].hourCnt[hourNumber].happyCnt = aButtonTemp +
                    aButtonPresses - aButtonHourStart;
                lastWeekData.responses[dayNumber].hourCnt[hourNumber].neutralCnt = cButtonTemp +
                    cButtonPresses - cButtonHourStart;
                lastWeekData.responses[dayNumber].hourCnt[hourNumber].sadCnt = eButtonTemp + 
                    eButtonPresses - eButtonHourStart;
            }
            else{
                thisWeekData.week = week;
                thisWeekData.responses[dayNumber].day = day;
                thisWeekData.responses[dayNumber].happyCnt = aButtonTemp + 
                    aButtonPresses - aButtonDayStart;
                thisWeekData.responses[dayNumber].neutralCnt = cButtonTemp +
                    cButtonPresses - cButtonDayStart;
                thisWeekData.responses[dayNumber].sadCnt = eButtonTemp + 
                    eButtonPresses - eButtonDayStart;
                thisWeekData.responses[dayNumber].hourCnt[hourNumber].happyCnt = aButtonTemp +
                    aButtonPresses - aButtonHourStart;
                thisWeekData.responses[dayNumber].hourCnt[hourNumber].neutralCnt = cButtonTemp +
                    cButtonPresses - cButtonHourStart;
                thisWeekData.responses[dayNumber].hourCnt[hourNumber].sadCnt = eButtonTemp + 
                    eButtonPresses - eButtonHourStart;
            }
            //prevDayNumber = dayNumber;
            //prevHourNumber = hourNumber;
            prevIndex = i;
        }
        if (!lastWeek){
            let totPressed = 0
            let promoters = 0;
            let detractors = 0;
    
            aButtonPresses = aButtonPresses + aButtonTemp - aButtonWeekStart;
            bButtonPresses = bButtonPresses + bButtonTemp - bButtonWeekStart;
            cButtonPresses = cButtonPresses + cButtonTemp - cButtonWeekStart;
            dButtonPresses = dButtonPresses + dButtonTemp - dButtonWeekStart;
            eButtonPresses = eButtonPresses + eButtonTemp - eButtonWeekStart;
    
            // Calc lastest NPS
            totPressed = aButtonPresses + /*bButtonPresses + */cButtonPresses + 
                /*dButtonPresses + */eButtonPresses;
            promoters = aButtonPresses;
            detractors = eButtonPresses;    
            npsScore = (promoters / totPressed * 100) - (detractors / totPressed * 100);

            // Calc prevois NPS
            totPressed = aButtonWeekStart + /*bButtonWeekStart + */cButtonWeekStart + 
                /*dButtonWeekStart + */eButtonWeekStart;
            promoters = aButtonWeekStart;
            detractors = eButtonWeekStart;    
            npsPrevScore = (promoters / totPressed * 100) - (detractors / totPressed * 100);

            delta = aButtonPresses + bButtonPresses + cButtonPresses + 
                dButtonPresses + eButtonPresses - totPressed 
        }
    }
    return {
        npsScore,
        aButtonPresses,
        bButtonPresses,
        cButtonPresses,
        dButtonPresses,
        eButtonPresses,
        lastWeekData,
        thisWeekData,
        diff: npsScore - npsPrevScore,
        delta: delta
    };
}

function updateStats(deviceData){
    let aButtonPresses = 0;
    //let bButtonPresses = 0;
    let cButtonPresses = 0;
    //let dButtonPresses = 0;
    let eButtonPresses = 0;
    let aButtonTemp = 0;
    //let bButtonTemp = 0;
    let cButtonTemp = 0;
    //let dButtonTemp = 0;
    let eButtonTemp = 0;
    let dayNumber = 0;
    let hourNumber = 0;
    let aButtonHourStart = 0;
    //let bButtonHourStart = 0;
    let cButtonHourStart = 0;
    //let dButtonHourStart = 0;
    let eButtonHourStart = 0;
    let aButtonDayStart = 0;
    //let bButtonDayStart = 0;
    let cButtonDayStart = 0;
    //let dButtonDayStart = 0;
    let eButtonDayStart = 0;
    //let aButtonWeekStart = 0;
    //let bButtonWeekStart = 0;
    //let cButtonWeekStart = 0;
    //let dButtonWeekStart = 0;
    //let eButtonWeekStart = 0;
    let day = 0;
    let week = 0;
    let weekStats = [deepCopyWeekData(weekData)];
    let weekCnt = 0;
    
    if (deviceData.length !== 0){
    
        let startTime = new Date(deviceData[0].time);
        dayNumber = startTime.getDay() === 0 ? 6 : startTime.getDay() - 1;
        hourNumber = startTime.getHours();
        aButtonTemp = aButtonHourStart = aButtonDayStart = deviceData[0].aButtonPresses;
        //bButtonTemp = /*bButtonHourStart = bButtonDayStart = */deviceData[0].bButtonPresses;
        cButtonTemp = cButtonHourStart = cButtonDayStart = deviceData[0].cButtonPresses;
        //dButtonTemp = /*dButtonHourStart = dButtonDayStart = */deviceData[0].dButtonPresses;
        eButtonTemp = eButtonHourStart = eButtonDayStart = deviceData[0].eButtonPresses;
        day = startTime.getDate();
        week = ISO8601_week_no(startTime);
                
        let prevIndex = 0;
        for (let i = 0; i < deviceData.length; i++){
            let sampleTime = new Date(deviceData[i].time);
            
            if (ISO8601_week_no(sampleTime) > week){
                aButtonHourStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                //bButtonHourStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                cButtonHourStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                //dButtonHourStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                eButtonHourStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                aButtonDayStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                //bButtonDayStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                cButtonDayStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                //dButtonDayStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                eButtonDayStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                //aButtonWeekStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                //bButtonWeekStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                //cButtonWeekStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                //dButtonWeekStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                //eButtonWeekStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
        
                hourNumber = sampleTime.getHours();
                dayNumber = sampleTime.getDay() === 0 ? 6 : sampleTime.getDay() - 1;
                day = sampleTime.getDate();
                week = ISO8601_week_no(sampleTime);
                weekStats.push(deepCopyWeekData(weekData))
                weekCnt++;
            }
            else{
                // Check if hour change
                let h = sampleTime.getHours();
                if (hourNumber !== h){
                    // Save Hour data
                    aButtonHourStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                    //bButtonHourStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                    cButtonHourStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                    //dButtonHourStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                    eButtonHourStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                
                    hourNumber = h;
                }
                
                // Check if day change
                let d = sampleTime.getDay() === 0 ? 6 : sampleTime.getDay() - 1;
                if (dayNumber !== d){
                    // Save Day data
                    aButtonDayStart = deviceData[prevIndex].aButtonPresses + aButtonPresses;
                    //bButtonDayStart = deviceData[prevIndex].bButtonPresses + bButtonPresses;
                    cButtonDayStart = deviceData[prevIndex].cButtonPresses + cButtonPresses;
                    //dButtonDayStart = deviceData[prevIndex].dButtonPresses + dButtonPresses;
                    eButtonDayStart = deviceData[prevIndex].eButtonPresses + eButtonPresses;
                    
                    dayNumber = d;
                    day = sampleTime.getDate();
                    week = ISO8601_week_no(sampleTime);
                }
            }
            if (aButtonTemp > deviceData[i].aButtonPresses)
                aButtonPresses += aButtonTemp;
            aButtonTemp = deviceData[i].aButtonPresses;
            //if (bButtonTemp > deviceData[i].bButtonPresses)
            //    bButtonPresses += bButtonTemp;
            //bButtonTemp = deviceData[i].bButtonPresses;
            if (cButtonTemp > deviceData[i].cButtonPresses)
                cButtonPresses += cButtonTemp;
            cButtonTemp = deviceData[i].cButtonPresses;
            //if (dButtonTemp > deviceData[i].dButtonPresses)
            //    dButtonPresses += dButtonTemp;
            //dButtonTemp = deviceData[i].dButtonPresses;
            if (eButtonTemp > deviceData[i].eButtonPresses)
                eButtonPresses += eButtonTemp;
            eButtonTemp = deviceData[i].eButtonPresses;

            weekStats[weekCnt].week = week;
            weekStats[weekCnt].responses[dayNumber].day = day;
            weekStats[weekCnt].responses[dayNumber].happyCnt = aButtonTemp + 
                aButtonPresses - aButtonDayStart;
            weekStats[weekCnt].responses[dayNumber].neutralCnt = cButtonTemp +
                cButtonPresses - cButtonDayStart;
            weekStats[weekCnt].responses[dayNumber].sadCnt = eButtonTemp + 
                eButtonPresses - eButtonDayStart;
            weekStats[weekCnt].responses[dayNumber].hourCnt[hourNumber].happyCnt = aButtonTemp +
                aButtonPresses - aButtonHourStart;
            weekStats[weekCnt].responses[dayNumber].hourCnt[hourNumber].neutralCnt = cButtonTemp +
                cButtonPresses - cButtonHourStart;
            weekStats[weekCnt].responses[dayNumber].hourCnt[hourNumber].sadCnt = eButtonTemp + 
                eButtonPresses - eButtonHourStart;
            prevIndex = i;
        }
    }
    return weekStats;
}

function copyStats(stats){
    const lastWeekData = deepCopyWeekData(stats.lastWeekData);
    const thisWeekData = deepCopyWeekData(stats.thisWeekData);
    return {...stats, lastWeekData, thisWeekData};
}

function ISO8601_week_no(dt) {
    let tdt = new Date(dt.valueOf());
    let dayn = (dt.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    let firstThursday = tdt.valueOf();
     
    tdt.setMonth(0, 1);
    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
    }
    
    return 1 + Math.ceil((firstThursday - tdt) / 604800000);
}

function deepCopyWeekData(data){
    let responses = data.responses.map(k => {
        let hourCnt = k.hourCnt.map(l => ({...l}));
        return {...k, hourCnt};
    });
    return {...data, responses}
}

// Data Structure
const weekData = {
    week: null,
    responses: [
        {
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },{
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },{
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },{
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },{
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },{
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },{
            day: null,
            happyCnt: null,
            neutralCnt: null,
            sadCnt: null,
            hourCnt: [
                {
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                },{
                    happyCnt: null,
                    neutralCnt: null,
                    sadCnt: null,
                }
            ]
        },
    ]
};
/*
const thisWeekData = [
    {
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },{
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },{
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },{
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },{
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },{
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },{
        happyCnt: null,
        neutralCnt: null,
        sadCnt: null,
        hourCnt: [
            {
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            },{
                happyCnt: null,
                neutralCnt: null,
                sadCnt: null,
            }
        ]
    },
];
*/